/**
 * 积分消耗
 * @returns
 */

import {
  Box,
  Flex,
  Text,
  Image,
  Button,
  HStack,
  Avatar,
} from "@chakra-ui/react";
import { Consume } from "@/types/integral";
import levelImg1 from "@/assets/images/integral_level1.png";
import levelImg2 from "@/assets/images/integral_level2.png";
import levelImg3 from "@/assets/images/integral_level3.png";
import tagImg1 from "@/assets/images/integral_tag1.png";

type Props = {
  consume: Consume;
};

const IntegralConsumeItem = ({ consume }: Props) => {
  const { product_name, level, price, img_url, avatar_url, username } = consume;

  return (
    <Box
      w="100%"
      // maxW={"221px"}
      h="221px"
      backgroundImage={`url('${img_url}')`}
      position="relative"
      sx={{
        backgroundSize: "cover",
        backgroundPosition:"center center",
        bgRepeat:"no-repeat"
      }}
    >
      <Box
        display={level == 1 ? "block" : "none"}
        position={"absolute"}
        top="0"
        right={"12px"}
      >
        <Image src={levelImg1} />
      </Box>
      <Box
        display={level == 2 ? "block" : "none"}
        position={"absolute"}
        top="0"
        right={"12px"}
      >
        <Image src={levelImg2} />
      </Box>
      <Box
        display={level == 3 ? "block" : "none"}
        position={"absolute"}
        top="0"
        right={"12px"}
      >
        <Image src={levelImg3} />
      </Box>
      <Box position={"absolute"} bottom="0" left="0" p="12px">
        <HStack mb="6px">
          <Image src={`${tagImg1}`} />
          <Text ml="6px" color={"#FFFFFF"} fontSize="10px" fontWeight={500}>
            {product_name}
          </Text>
        </HStack>
        <HStack>
          <Avatar
            src={avatar_url ? avatar_url : "https://bit.ly/dan-abramov"}
            w={"18px"}
            h={"18px"}
          />
          <Text ml="4px" color={"#E6E6E6"} fontSize="8px" fontWeight={350}>
            {username}
          </Text>
        </HStack>
      </Box>
      <Box
        position={"absolute"}
        top="0"
        left="0"
        w="100%"
        h="100%"
        bg="rgba(0, 0, 0, 0.6)"
        opacity={0}
        transition = "all 0.2s"
        _hover={{
          opacity: 1
        }}
      >
        <Flex h="100%" flexDirection={"column"} justifyContent="center" align={"center"} gap="8px">
          <Box fontSize="10px" color={"#E6E6E6"}>
            {username}-{product_name}
          </Box>
          <HStack>
            <Text color={"#FFFFFF"} fontSize="18px" fontWeight={500}>
              {price}
            </Text>
            <Text color={"#FFFFFF"} fontSize="12px" fontWeight={350}>
              积分
            </Text>
          </HStack>
          <Button
            width={"68px"}
            height={"30px"}
            borderRadius="40px"
            color="#FCEBCF"
            bg="none"
            fontWeight={"normal"}
            sx={{
              boxSizing: "border-box",
              border: "1px solid #FCEBCF",
              // borderImage: "linear-gradient(90deg, #FCEBCF 0%, #F8D689 100%) 1",
            }}
            fontSize="12px"
            _hover={{
              color: "#F8D689",
              bg: "none",
              border: "1px solid #F8D689",
            }}
          >
            去体验
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default IntegralConsumeItem;
